import type {Component, Editor} from 'grapesjs';
import type {InfoBoxDescriptor} from '../info-box-control/info-box-control.types';

export interface FontEntry {
  id: string;
  value: string;
  name: string;
}

/** `value` is the CSS font-family string written to the component style. */
export const FONT_LIST: readonly FontEntry[] = [
  {id: 'arial', value: 'Arial, Helvetica, sans-serif', name: 'Arial'},
  {id: 'arial-black', value: 'Arial Black', name: 'Arial Black'},
  {id: 'brush-script-mt', value: 'Brush Script MT, sans-serif', name: 'Brush Script MT'},
  {id: 'comic-sans-ms', value: 'Comic Sans MS, cursive, sans-serif', name: 'Comic Sans MS'},
  {id: 'courier-new-courer', value: 'Courier New Courier, monospace', name: 'Courier New Courier'},
  {id: 'georgia', value: 'Georgia, serif', name: 'Georgia'},
  {id: 'helvetica', value: 'Helvetica, sans-serif', name: 'Helvetica'},
  {id: 'impact', value: 'Impact, Charcoal, sans-serif', name: 'Impact'},
  {id: 'lucida-sans-unicode', value: 'Lucida Sans Unicode, Lucida Grande, sans-serif', name: 'Lucida Sans Unicode'},
  {id: 'source-sans-pro', value: 'Source Sans Pro, Helvetica, Arial', name: 'Source Sans Pro'},
  {id: 'tahoma', value: 'Tahoma, Geneva, sans-serif', name: 'Tahoma'},
  {id: 'times-new-roman', value: 'Times New Roman, Times, serif', name: 'Times New Roman'},
  {id: 'trebuchet-ms', value: 'Trebuchet MS, Helvetica, sans-serif', name: 'Trebuchet MS'},
  {id: 'verdana', value: 'Verdana, Geneva, sans-serif', name: 'Verdana'},
] as const;

export const DEFAULT_FONT: FontEntry = {
  id: 'helvetica',
  value: 'Helvetica, sans-serif',
  name: 'Helvetica',
};

export const FONT_FAMILY_PROPERTY = 'font-family';

export interface FontSelectorDescriptor {
  property: string;
  labelKey: string;
  onFontChange?: (component: Component, editor: Editor) => void;
  fallbackProperty?: string;
}

export const DEFAULT_FONT_SELECTOR_DESCRIPTOR: FontSelectorDescriptor = {
  property: FONT_FAMILY_PROPERTY,
  labelKey: 'pmwjs_font',
};

export const FONTS_WARNING_DESCRIPTOR: InfoBoxDescriptor = {contentKey: 'pmwjs_fonts_email_warning'};
